import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BranchCategoryModel } from 'common/models/page-models/branch-category/branch-category-data.model';
import { BranchCategoryListingModel } from 'common/models/page-models/branch-category/branch-category-grid.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { BranchCategoryGridWidgetService } from 'common/widget/branch-category/branch-category-grid-widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class BranchCategoryGridResolver extends GridResolver<BranchCategoryModel, BranchCategoryListingModel> {
    constructor(
        protected fs: BranchCategoryGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}